module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade in",
    class: ['modal-' + _vm.type],
    staticStyle: {
      "padding-right": "17px",
      "display": "none"
    },
    style: ({
      display: _vm.innerValue ? 'block' : 'none'
    })
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.modalSizeClass,
    style: (_vm.modalStyle)
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.closable) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("modal-header", [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.header))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [_c('button', {
    staticClass: "btn pull-left",
    class: [!_vm.type ? 'btn-default' : 'btn-outline'],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: [!_vm.type ? 'btn-primary' : 'btn-outline'],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.okClick
    }
  }, [_vm._v(_vm._s(_vm.okText))])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc45aa3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = 36
// module chunks = 0